import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import TextButton from "@/components/TextButton";
import { useCampground } from "@/contexts/AppConfigContext";
import { useBookingContext } from "@/contexts/BookingContext";
import { useStepNavigation } from "@/hooks/useStepNavigation";
import { formatDateRange, formatGuests, getCampsiteTypeLabel } from "@/utils/booking";

export default function BookingSearchDetails() {
  const { i18n } = useLingui();
  const { state } = useBookingContext();
  const { data: campgroundData } = useCampground();
  const { goToStep } = useStepNavigation();

  const handleEdit = () => {
    goToStep("dates");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: { sm: "wrap" },
        rowGap: { sm: 1 },
        justifyContent: "space-between",
        alignItems: { xs: "center", sm: "flex-start" },
      }}
    >
      <Typography
        variant="body1"
        sx={{ textTransform: "capitalize", flex: 1, minWidth: 0, display: { sm: "none" } }}
      >
        {[
          getCampsiteTypeLabel(state.selectedCampsiteType, campgroundData.campsite_types),
          formatDateRange([state.dateFrom, state.dateUntil], i18n.locale),
          formatGuests(state.selectedPersons, campgroundData.campground?.persons || []),
        ].join(" | ")}
      </Typography>
      <Stack
        sx={{ flex: "1 1 auto", minWidth: 0, display: { xs: "none", sm: "flex" } }}
        direction="column"
        spacing={0}
      >
        <Typography
          variant="body1"
          sx={{
            color: "text.primary",
            whiteSpace: "pre-wrap",
            textTransform: "capitalize",
            textOverflow: "ellipsis",
          }}
        >
          {getCampsiteTypeLabel(state.selectedCampsiteType, campgroundData.campsite_types)}
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: "pre-wrap", textOverflow: "ellipsis" }}>
          {formatDateRange([state.dateFrom, state.dateUntil], i18n.locale)}
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: "pre-wrap", textOverflow: "ellipsis" }}>
          {formatGuests(state.selectedPersons, campgroundData.campground?.persons || [])}
        </Typography>
      </Stack>
      <IconButton
        onClick={handleEdit}
        sx={{
          ml: 1,
          display: { sm: "none" },
          bgcolor: "primary.main",
          color: "white",
          width: 28,
          height: 28,
        }}
      >
        <EditIcon sx={{ fontSize: 14 }} />
      </IconButton>
      <TextButton
        onClick={handleEdit}
        sx={{ flex: "0 0 auto", display: { xs: "none", sm: "inline-flex" } }}
      >
        <Trans>Edit search</Trans>
      </TextButton>
    </Box>
  );
}
